import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import {
  ProjectData,
  ProjectWithJurisdictionLocations,
} from 'src/app/shared/interfaces/project-data.interface';
import { ProjectsService } from 'src/app/shared/services/projects/projects.service';

export const filterProjectsByJurisdictionResolver: ResolveFn<ProjectData> = (
  _,
  __
) => {
  const _projectService = inject(ProjectsService);
  const _route = inject(Router);

  const jurisdictionName =
    _route.getCurrentNavigation()?.extras?.state?.['jurisdictionName'];
  const locationName =
    _route.getCurrentNavigation()?.extras?.state?.['locationName'];

  return _projectService.getProjectsList().pipe(
    take(1),
    map(projectData => {
      const filtered = projectData.projectsWageData.filter(
        (project: ProjectWithJurisdictionLocations) => {
          return (
            project.jurisdictionCodes?.some(jurisdiction => {
              return jurisdiction.description === jurisdictionName;
            }) &&
            project.locationCodes?.some(location => {
              return location.locationDescription === locationName;
            })
          );
        }
      );
      return {
        projectsWageData: filtered,
        count: filtered.length,
      } as ProjectData;
    })
  );
};
